import { cache, } from "./cache";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getBracketRate,} from "@bracket/contractor-next/brktETH";



/**
 * Gets the current exchange rate of BRKT to ETH from the contract
 * Uses a cached value if available and not expired
 * @returns Promise resolving to the current BRKT/ETH exchange rate as a number
 */
export const bracketRate = async (): Promise<number> => {
	const now = Date.now();
	const {
		time,
		value,
		since,
	} = cache.bracket_rate;
	if(since > now - time) {
		return value;
	}
	const next = await getBracketRate({ config, }) as Awaited<number>;
  if(typeof next === "number") {
    cache.bracket_rate.since = Date.now();
    cache.bracket_rate.value = next;
    return cache.bracket_rate.value;
  }
  console.warn("bracketRate failed to gain a valid value");
	return next;
}
